import React from 'react';

const Policy: React.FC = () => {
  return (
    <div className="space-y-12 max-w-4xl mx-auto">
      <section className="card-natural">
        <h1 className="text-4xl font-bold text-clay-500 mb-6">Policy Statement</h1>
        <p className="text-earth-400 italic mb-6">
          As a Registered Family Home Daycare Provider, I am pleased to present the following information regarding my policies and procedures.
        </p>
      </section>

      <section className="card-natural">
        <h2 className="text-3xl font-bold text-clay-500 mb-6">Educational Philosophy</h2>
        <div className="space-y-4 text-earth-400">
          <p>
            My program embraces a play-based curriculum, recognizing that the first five years of a child's life are crucial for cognitive and emotional development. Research consistently demonstrates that children learn most effectively through purposeful play and exploration.
          </p>
          <p>
            My daily schedule is thoughtfully structured while remaining flexible to accommodate individual needs and interests. I implement developmentally appropriate activities designed to foster growth across all domains: physical, cognitive, linguistic, and social-emotional.
          </p>
          <p>
            In an era where children are increasingly engaged with digital devices, I prioritize outdoor learning experiences. My program emphasizes the importance of fresh air, natural exploration, and unstructured play as essential components of healthy development.
          </p>
          <p>
            I believe in creating an environment where children feel secure and valued as they develop meaningful relationships with peers and caregivers. My approach balances structure with self-directed learning, allowing children to discover their interests and capabilities.
          </p>
        </div>
      </section>

      <section className="card-natural">
        <h2 className="text-3xl font-bold text-clay-500 mb-6">Hours of Operation</h2>
        <div className="space-y-4 text-earth-400">
          <p className="font-semibold">Weekdays: 7:15 AM - 4:30 PM</p>
          <p className="italic">In compliance with childcare regulations, I am unable to accommodate children beyond contracted hours.</p>
          <p className="bg-clay-100 p-4 rounded-lg font-semibold">
            *A late fee of $1 per minute will be assessed for pick-ups after 4:30 PM*
          </p>
        </div>
      </section>

      <section className="card-natural">
        <h2 className="text-3xl font-bold text-clay-500 mb-6">Fee Schedule</h2>
        <div className="space-y-4">
          <div className="bg-sage-100 p-6 rounded-lg">
            <h3 className="text-2xl font-semibold text-sage-500 mb-4">Rates (Effective August 2024)</h3>
            <ul className="list-disc list-inside text-earth-400 space-y-2">
              <li>Full-time care: $44 per day per child</li>
              <li>After-school care: $80 per week per child</li>
              <li>Infant care (under 24 months): $225 per week</li>
            </ul>
          </div>
          <div>
            <h3 className="text-2xl font-semibold text-clay-400 mb-4">Payment Schedule</h3>
            <ul className="list-disc list-inside text-earth-400 space-y-2">
              <li>Monthly payments due on the first of each month, or</li>
              <li>Weekly payments due each Monday</li>
            </ul>
            <p className="mt-4 text-earth-400 italic">Timely payments are required to maintain enrollment.</p>
          </div>
        </div>
      </section>

      <section className="card-natural">
        <h2 className="text-3xl font-bold text-clay-500 mb-6">Contact Information</h2>
        <div className="space-y-4 text-earth-400">
          <p className="font-semibold">Ann Schaefer</p>
          <p>2713 Webb Road</p>
          <p>Lafayette, New York 13084</p>
          <p>Primary: (315) 395-6193</p>
          <p>Secondary: (315) 677-8211</p>
          <p>Email: annkatniss@gmail.com</p>
          <p className="italic mt-4">
            For inquiries during or outside of operating hours, please feel free to call, text, or email. I will respond to all messages promptly.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Policy; 